angular.module("ainapp")
    .controller("addEmployeeAppraisalsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Employee Appraisals";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.basePath = config.basePath;

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })

            $scope.updateDetails = function () {

                MainService.EmployeeAppraisalsById($stateParams.AppId).then(function (response) {
                    if (response.data) {
                        $scope.Appraisal = response.data;
                        $scope.Appraisal.Date = new Date(response.data.Date);

                        $scope.PayrollComponents = [];
                        MainService.PayrollComponentsInEmployee().then(function (response2) {
                            $scope.PayrollComponents = response2.data;
                            angular.forEach($scope.PayrollComponents, function (e) {

                                var found = 0;
                                angular.forEach($scope.Appraisal.EmployeeAppraisalPayrolls, function (a) {
                                    if (a.PayrollComponentId == e.Id) {
                                        found = 1;
                                    }
                                })

                                if (found == 0) {
                                    var temp = {
                                        Type: e.Type,
                                        PayrollComponentId: e.Id,
                                        PayrollComponent: e,
                                        Amount: 0,
                                    }
                                    $scope.Appraisal.EmployeeAppraisalPayrolls.push(temp);
                                }


                            })
                        })


                    }
                    $scope.load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }

            $scope.Init = function () {

                $scope.Appraisal = {
                    EmployeeId: "",
                    Date: new Date(),
                    NetSalary: 0,
                    BasicSalary: 0,
                    Percentage: 0,
                    AnnualCTC: 0,
                    Remarks: "",
                    Reason: "",

                    EmployeeAppraisalPayrolls: [],
                }

                if ($stateParams.AppId > 0) {

                    $scope.updateDetails();

                } else {
                    $scope.PayrollComponents = [];
                    MainService.PayrollComponentsInEmployee().then(function (response) {
                        $scope.PayrollComponents = response.data;
                        angular.forEach($scope.PayrollComponents, function (e) {
                            var temp = {
                                Type: e.Type,
                                PayrollComponentId: e.Id,
                                PayrollComponent: e,
                                Amount: 0,
                            }
                            $scope.Appraisal.EmployeeAppraisalPayrolls.push(temp);
                        })
                    })

                }




            }
            $scope.Init();


            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.TokenInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteEmployeeAppraisal($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $state.go("EmployeeAppraisals");
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }

            $scope.AddData = function () {

                if (!$scope.TokenInfo.IsAdd && !$scope.Appraisal.Id > 0 && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToAddData);
                } else if (!$scope.TokenInfo.IsEdit && $scope.Appraisal.Id > 0 && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToEditData);

                } else if ($scope.Appraisal.EmployeeId == "") {
                    toastr.warning($scope.LanguageData.SelectEmployee);
                } else if ($scope.Appraisal.NetSalary == 0) {
                    toastr.warning($scope.LanguageData.AddNetSalary);
                } else if ($scope.Appraisal.BasicSalary == 0) {
                    toastr.warning($scope.LanguageData.AddBasicSalary);
                } else if ($scope.Appraisal.Percentage == 0) {
                    toastr.warning($scope.LanguageData.AddPercentage);
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddEmployeeAppraisal($scope.Appraisal).then(function (response) {
                        if (response.data) {
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                            $scope.load = 0;
                        } else {
                            toastr.error($scope.LanguageData.Error);
                            $scope.load = 0;
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }






                }])
